// RejectionModal.jsx
import React from "react";

const RejectionModal = ({
  isOpen,
  request,
  rejectionReason,
  onRejectionReasonChange,
  onConfirmReject,
  onCancel,
  type = "deposit"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white border border-slate-300 rounded-lg p-6 w-full max-w-md shadow-xl">
        <h3 className="text-lg font-semibold mb-4 text-slate-800">
          Reject {type === "deposit" ? "Deposit" : "Withdrawal"} Request
        </h3>
        <p className="text-slate-600 mb-4">
          Rejecting {type} from <strong className="text-slate-800">{request?.username}</strong> for{" "}
          <strong className="text-slate-800">${request?.amount?.toFixed(2)}</strong>
        </p>
        <div className="mb-4">
          <label className="block text-slate-700 mb-2 font-medium">Rejection Reason:</label>
          <textarea
            value={rejectionReason}
            onChange={(e) => onRejectionReasonChange(e.target.value)}
            placeholder="Enter reason for rejection..."
            className="w-full border border-slate-300 bg-white text-slate-800 rounded-lg py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="3"
          />
        </div>
        <div className="flex space-x-3">
          <button
            onClick={onConfirmReject}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded font-medium transition-colors flex-1 shadow-sm"
          >
            Confirm Reject
          </button>
          <button
            onClick={onCancel}
            className="bg-slate-500 hover:bg-slate-600 text-white px-4 py-2 rounded font-medium transition-colors flex-1 shadow-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;
